module.exports = __webpack_public_path__ + "static/davidson-icon-84be9896530477d72f961983ffbe0c80.png";